import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setLastClick } from "../state/user/userSlice"
import store from "../state/store"
import { logoutAction, updateAlert } from "../state/login/loginSlice"
import { updateSelectedOrg } from "../state/organisation/organisationSlice"
import { updateSelectedClinic } from "../state/clinic/clinicSlice"
import { endLoginTimeTracker, updateTimeTracker } from "../state"
import { userLoggedOut } from "../state/rootReducer"
import { navigate } from "gatsby"
import CloseIcon from "@mui/icons-material/Close"
import {
    updateIsTimeTrackerForced,
    updateTime,
    updateTimerPlaying,
} from "../state/patient/patientSlice"
let GuidedTour = null
if (typeof window !== undefined) {
    GuidedTour = require("./GuidedTour").default
}

const Layout = ({ children }) => {
    const [showMessage, setShowMessage] = useState(false)
    const dispatch = useDispatch()
    const loggedIn = useSelector(state => state.login.loggedin)
    const intervalRef = useRef(null) // Reference for setInterval
    const alert = useSelector(state => state.login.alert)
    const timerPlaying = useSelector(state => state.patients.timerPlaying)
    const activePage =
        typeof window !== "undefined" ? window.location.pathname : "/"

    useEffect(() => {
        if (process.env.GATSBY_URL_TYPE === "PROD") {
            // console.log = () => {}
            // console.warn = () => {}
            // console.error = () => {}
        }
    }, [])

    // useEffect(() => {
    //     if (!loggedIn) {
    //         if (showMessage) setShowMessage(false)
    //         return
    //     }
    //     // Handle click and update Redux state
    //     const handleClick = () => {
    //         localStorage.setItem("lastClicked", new Date().getTime() + "")
    //         dispatch(setLastClick(new Date().getTime()))
    //     }

    //     // Attach click event listener
    //     document.addEventListener("click", handleClick)

    //     // Start interval to check for inactivity
    //     // intervalRef.current = setInterval(async () => {
    //     //     const lastClickedTime = store.getState().user.lastClick
    //     //     const currentTime = new Date().getTime()
    //     //     const lc = await localStorage.getItem("lastClicked")
    //     //     if (lastClickedTime < new Date().getTime() - 1000 * 60 * 7) {
    //     //         if (lc < new Date().getTime() - 1000 * 60 * 7) {
    //     //             localStorage.setItem(
    //     //                 "lastClicked",
    //     //                 new Date().getTime() + ""
    //     //             )
    //     //             if (
    //     //                 activePage.includes("/patients/patient") &&
    //     //                 timerPlaying
    //     //             ) {
    //     //                 dispatch(updateTimerPlaying(false))
    //     //                 dispatch(updateIsTimeTrackerForced(false))
    //     //                 dispatch(updateTimeTracker())
    //     //                 dispatch(updateTime(null))
    //     //             }
    //     //             dispatch(logoutAction())
    //     //             dispatch(
    //     //                 updateSelectedOrg({
    //     //                     organizationId: null,
    //     //                     organizationName: "",
    //     //                 })
    //     //             )
    //     //             dispatch(
    //     //                 updateSelectedClinic({ clinicId: null, clinicName: "" })
    //     //             )
    //     //             dispatch(endLoginTimeTracker(false))
    //     //             dispatch(userLoggedOut())
    //     //             dispatch(setLastClick(new Date().getTime()))
    //     //             dispatch(
    //     //                 updateAlert({
    //     //                     ...alert,
    //     //                     open: true,
    //     //                     type: "error",
    //     //                     msg: "Logged out due to inactivity!",
    //     //                 })
    //     //             )
    //     //             navigate("/login")
    //     //             if (typeof window !== undefined) {
    //     //                 setTimeout(() => {
    //     //                     window.location.reload()
    //     //                 }, 10)
    //     //             }
    //     //         }
    //     //     }
    //     //     if (lastClickedTime < currentTime - 1000 * 60 * 5) {
    //     //         if (lc < currentTime - 1000 * 60 * 5) {
    //     //             if (!showMessage) setShowMessage(true) // Show message if inactive
    //     //         }
    //     //     } else {
    //     //         if (showMessage) setShowMessage(false) // Hide message if active
    //     //     }
    //     // }, 1000)

    //     // Cleanup event listener and interval on component unmount
    //     return () => {
    //         document.removeEventListener("click", handleClick)
    //         if (intervalRef.current) {
    //             clearInterval(intervalRef.current)
    //         }
    //     }
    // }, [dispatch, showMessage, loggedIn])

    useEffect(() => {
        localStorage.setItem("lastClicked", new Date().getTime() + "")
        dispatch(setLastClick(new Date().getTime()))
    }, [loggedIn])

    return (
        <div>
            {/* {typeof window !== undefined && <GuidedTour />} */}
            {/* Display message if inactive */}
            {loggedIn && showMessage && (
                <div
                    style={{
                        position: "fixed",
                        background: "#FFAC1C",
                        color: "white",
                        padding: 15,
                        top: 20,
                        borderRadius: 5,
                        zIndex: 9999999,
                        alignSelf: "center",
                        left: "50%",
                        transform: "translate(-50%, 0)",
                    }}
                >
                    <p style={{ marginRight: 20 }}>
                        You will be logged out soon due to inactivity.
                    </p>
                    <CloseIcon
                        sx={{
                            position: "absolute",
                            right: 5,
                            top: 5,
                            cursor: "pointer",
                        }}
                    />
                </div>
            )}
            {children}
        </div>
    )
}

export default Layout
